var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRetry(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.62181 4.7827L6.27172 5.23777C6.33061 5.27901 6.3746 5.33818 6.39711 5.40647C6.45474 5.58131 6.35972 5.76976 6.18488 5.8274L3.92703 6.57163C3.8963 6.58176 3.86425 6.58737 3.8319 6.58826C3.64787 6.59335 3.49457 6.44829 3.48948 6.26427L3.4239 3.89316C3.42193 3.82163 3.44302 3.75137 3.48406 3.69275C3.58965 3.54195 3.7975 3.5053 3.9483 3.61089L4.48591 3.98733C5.44348 3.14772 6.68249 2.6665 7.99984 2.6665C10.9454 2.6665 13.3332 5.05432 13.3332 7.99984C13.3332 10.9454 10.9454 13.3332 7.99984 13.3332C5.05432 13.3332 2.6665 10.9454 2.6665 7.99984H3.99984C3.99984 10.209 5.7907 11.9998 7.99984 11.9998C10.209 11.9998 11.9998 10.209 11.9998 7.99984C11.9998 5.7907 10.209 3.99984 7.99984 3.99984C7.12553 3.99984 6.29829 4.28172 5.62181 4.7827Z",
    fill: "#8D8D8D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRetry);
export default __webpack_public_path__ + "static/media/retry.64a95875befaed7f08d95007cb8d284d.svg";
export { ForwardRef as ReactComponent };